import apiCall from "../api";

export const listStorageFiles = async (prefix = "") => {
  const response = await apiCall(`/storage/list?prefix=${prefix}`, "GET");
  return response.data.data;
};

export const uploadStorageFile = async ({
  file,
  folder,
  name,
}: {
  file: File;
  folder: string;
  name?: string;
}) => {
  const formData = new FormData();

  formData.append("file", file);
  formData.append("folder", folder);

  if (name) {
    formData.append("name", name);
  }

  const response = await apiCall("/storage/upload", "POST", formData);
  return response.data.data;
};

export const deleteStorageFile = async (key: string) => {
  const response = await apiCall(
    "/storage/delete",
    "DELETE",
    { key },
    { "Content-Type": "application/json" },
  );

  return response.data.data;
};
